import React, { useEffect } from "react";
import moment from 'moment';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./InAppNotificationsPage.scss";
import NotificationItem from "./NotificationItem";
import EmptyStateInAppNotifications from "./EmptyStateInAppNotifications";
import { NotificationActionTypes } from "./NotificationActionTypes";
import ShiftDetailModals from "pages/ScheduleCalendar/components/TableComponents/ShiftDetail/ShiftDetailModals";
import { isTheEventRelatedToShiftDetail, isTheEventRelatedToScheduleView } from './NotificationUtils';
import { Redirect, withRouter, Link } from 'react-router-dom';

class InAppNotificationsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      openNotificationId: null,
      showShiftDetailModal: false,
    };
    this.shiftModalRef = React.createRef();
    this.handleScroll = this.handleScroll.bind(this);
  }

  // Detect when user has scrolled to the bottom
  handleScroll(e) {
    const scrollPosition = e.target.scrollTop + e.target.clientHeight;
    const bottom = e.target.scrollHeight - scrollPosition <= 20; // Tolerance of 20px
    if (bottom) {
      this.props.notifyLoadMore(); // Trigger load more
    }
  }

  // Handle actions when a user clicks an option
  handleOptionClick = (actionType, notification) => {
    const { notifyDeleteSingleNotification } = this.props;
    switch (actionType) {
      case NotificationActionTypes.MARK_AS_READ:
        console.log(`Notification ${notificationId} marked as read.`);
        break;
      case NotificationActionTypes.DELETE_SINGLE:
        console.log(`Notification ${notification} deleted.`);
        notifyDeleteSingleNotification(notification)
        break;
      default:
        console.log('Unknown action');
    }
  };

  handleNotificationItemClick = (notification) => {
    const { notifyDeleteSingleNotification, readSingleInAppNotification } = this.props;

    readSingleInAppNotification(notification.id);
    if (isTheEventRelatedToShiftDetail(notification.event)) {
      const shiftId = notification?.object_meta?.schedule_element_id;

      const shiftDate = moment(notification.object_meta.schedule_element_start_at);

      this.shiftModalRef.current?.openShiftDetail(null, shiftDate, null, shiftId);
    } else if (isTheEventRelatedToScheduleView(notification.event)) {
      this.props.history.push('/schedulecalendar');
    }
  };

  handleNotificationItemModalCancel = () => {
    this.setState({ showShiftDetailModal: false });
  }

  // Toggle the visibility of the options menu for a given notification
  toggleOptions = (notificationId) => {
    this.setState((prevState) => ({
      openNotificationId: prevState.openNotificationId === notificationId ? null : notificationId,
    }));
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { isPanelOpen, notifications, notifyDeleteSingleNotification } = this.props;
    const { openNotificationId } = this.state;
    const actionNeededNotifications = notifications.filter((notification) => {
      return (
        notification.object_meta && notification.object_meta.require_action
      );
    });

    const needsActionCopy = (<FormattedMessage id="Notifications.needsAction" defaultMessage="Needs Action" />);
    const allNotificationsCopy = (<FormattedMessage id="Notifications.all" defaultMessage="All Notifications" />);

    return (
      <div className={`notification-panel ${isPanelOpen ? "open" : ""}`} >
        <div
          className='notification-panel-wrap-style' // Attach the scroll event listener
          onScroll={this.handleScroll}
        >
          <Tabs>
            <TabList>
              <Tab>{allNotificationsCopy}</Tab>
              <Tab>{needsActionCopy}</Tab>
            </TabList>

            {/* "All Notifications" Tab - Show all notifications */}
            <TabPanel>
              <ul>
                {notifications.length > 0 ? (
                  notifications.map((notification, index) => (
                    <NotificationItem key={index}
                      notification={notification}
                      itemClick={this.handleNotificationItemClick}
                      notifyDeleteSingleNotification={notifyDeleteSingleNotification}
                      onOptionClick={this.handleOptionClick}
                      isOptionsOpen={openNotificationId === notification.id}
                      toggleOptions={() => this.toggleOptions(notification.id)} />
                  ))
                ) : (
                  <EmptyStateInAppNotifications />
                )}
              </ul>
            </TabPanel>
            {/* "Needs Actions" Tab */}
            <TabPanel>
              <ul>
                {actionNeededNotifications.length > 0 ? (
                  actionNeededNotifications.map((notification, index) => (
                    <NotificationItem key={index}
                      notification={notification}
                      itemClick={this.handleNotificationItemClick}
                      notifyDeleteSingleNotification={notifyDeleteSingleNotification}
                      onOptionClick={this.handleOptionClick}
                      isOptionsOpen={openNotificationId === notification.id}
                      toggleOptions={() => this.toggleOptions(notification.id)} />
                  ))
                ) : (
                  <EmptyStateInAppNotifications />
                )}
              </ul>
            </TabPanel>
          </Tabs>
        </div>

        <ShiftDetailModals
          ref={this.shiftModalRef}
          matrix={null}
          rangeStart={null}
          locationSettings={this.props.locationSettings}
          allUsers={this.props.allUsers}
        />
      </div>
    );
  };
}

export default withRouter(injectIntl(InAppNotificationsPage));